import { Switch } from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalc } from "../../model";

interface Props {
  calc: ICalc
}

@observer
export class CalcClassificacaoUser extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props);
  }

  render() {

    return (

      <>

        <div className="class-horizontal-form">

          <Switch
            className="select-regras"
            label="Uso e Consumo (Estadual)"
            checked={this.props.calc.uso_consumo_estadual}
            onChange={(e: any) => {
              this.props.calc.uso_consumo_estadual = e.target.checked
              this.props.calc.uso_consumo_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Uso e Consumo (Interestadual)"
            checked={this.props.calc.uso_consumo_interestadual}
            onChange={(e: any) => {
              this.props.calc.uso_consumo_interestadual = e.target.checked
              this.props.calc.uso_consumo_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Ativo Imobilizado (Estadual)"
            checked={this.props.calc.ativo_imobilizado_estadual}
            onChange={(e: any) => {
              this.props.calc.ativo_imobilizado_estadual = e.target.checked
              this.props.calc.ativo_imobilizado_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Ativo Imobilizado (Interestadual)"
            checked={this.props.calc.ativo_imobilizado_interestadual}
            onChange={(e: any) => {
              this.props.calc.ativo_imobilizado_interestadual = e.target.checked
              this.props.calc.ativo_imobilizado_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Transferência de Mercadoria (Estadual)"
            checked={this.props.calc.transferencia_mercadorias_estadual}
            onChange={(e: any) => {
              this.props.calc.transferencia_mercadorias_estadual = e.target.checked
              this.props.calc.transferencia_mercadorias_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Transferência de Mercadoria (Interestadual)"
            checked={this.props.calc.transferencia_mercadorias_interestadual}
            onChange={(e: any) => {
              this.props.calc.transferencia_mercadorias_interestadual = e.target.checked
              this.props.calc.transferencia_mercadorias_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Compra de Combustível pra uso e Consumo (Estadual)"
            checked={this.props.calc.combustivel_consumo_estadual}
            onChange={(e: any) => {
              this.props.calc.combustivel_consumo_estadual = e.target.checked
              this.props.calc.combustivel_consumo_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Compra de Combustível pra uso e Consumo (Interestadual)"
            checked={this.props.calc.combustivel_consumo_interestadual}
            onChange={(e: any) => {
              this.props.calc.combustivel_consumo_interestadual = e.target.checked
              this.props.calc.combustivel_consumo_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Remessa em Comodato (Estadual)"
            checked={this.props.calc.remessa_comodato_estadual}
            onChange={(e: any) => {
              this.props.calc.remessa_comodato_estadual = e.target.checked
              this.props.calc.remessa_comodato_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Remessa em Comodato (Interestadual)"
            checked={this.props.calc.remessa_comodato_interestadual}
            onChange={(e: any) => {
              this.props.calc.remessa_comodato_interestadual = e.target.checked
              this.props.calc.remessa_comodato_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Insumos pra industrialização (Estadual)"
            checked={this.props.calc.insumos_industrializacao_estadual}
            onChange={(e: any) => {
              this.props.calc.insumos_industrializacao_estadual = e.target.checked
              this.props.calc.insumos_industrializacao_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Insumos pra industrialização (Interestadual)"
            checked={this.props.calc.insumos_industrializacao_interestadual}
            onChange={(e: any) => {
              this.props.calc.insumos_industrializacao_interestadual = e.target.checked
              this.props.calc.insumos_industrializacao_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Baixa de Estoque (Estadual)"
            checked={this.props.calc.baixa_estoque_estadual}
            onChange={(e: any) => {
              this.props.calc.baixa_estoque_estadual = e.target.checked
              this.props.calc.baixa_estoque_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Baixa de Estoque (Interestadual)"
            checked={this.props.calc.baixa_estoque_interestadual}
            onChange={(e: any) => {
              this.props.calc.baixa_estoque_interestadual = e.target.checked
              this.props.calc.baixa_estoque_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Bonificação (Estadual)"
            checked={this.props.calc.bonificacao_estadual}
            onChange={(e: any) => {
              this.props.calc.bonificacao_estadual = e.target.checked
              this.props.calc.bonificacao_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Bonificação (Interestadual)"
            checked={this.props.calc.bonificacao_interestadual}
            onChange={(e: any) => {
              this.props.calc.bonificacao_interestadual = e.target.checked
              this.props.calc.bonificacao_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Retorno de Mercadoria (Estadual)"
            checked={this.props.calc.retorno_mercadoria_estadual}
            onChange={(e: any) => {
              this.props.calc.retorno_mercadoria_estadual = e.target.checked
              this.props.calc.retorno_mercadoria_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Retorno de Mercadoria (Interestadual)"
            checked={this.props.calc.retorno_mercadoria_interestadual}
            onChange={(e: any) => {
              this.props.calc.retorno_mercadoria_interestadual = e.target.checked
              this.props.calc.retorno_mercadoria_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Compra de Combustível pra Revenda (Estadual)"
            checked={this.props.calc.combustivel_revenda_estadual}
            onChange={(e: any) => {
              this.props.calc.combustivel_revenda_estadual = e.target.checked
              this.props.calc.combustivel_revenda_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Compra de Combustível pra Revenda (Interestadual)"
            checked={this.props.calc.combustivel_revenda_interestadual}
            onChange={(e: any) => {
              this.props.calc.combustivel_revenda_interestadual = e.target.checked
              this.props.calc.combustivel_revenda_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Remessa em Garantia (Estadual)"
            checked={this.props.calc.remessa_garantia_estadual}
            onChange={(e: any) => {
              this.props.calc.remessa_garantia_estadual = e.target.checked
              this.props.calc.remessa_garantia_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Remessa em Garantia (Interestadual)"
            checked={this.props.calc.remessa_garantia_interestadual}
            onChange={(e: any) => {
              this.props.calc.remessa_garantia_interestadual = e.target.checked
              this.props.calc.remessa_garantia_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Remessa para entrega Futura (Estadual)"
            checked={this.props.calc.remessa_entrega_futura_estadual}
            onChange={(e: any) => {
              this.props.calc.remessa_entrega_futura_estadual = e.target.checked
              this.props.calc.remessa_entrega_futura_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Remessa para entrega Futura (Interestadual)"
            checked={this.props.calc.remessa_entrega_futura_interestadual}
            onChange={(e: any) => {
              this.props.calc.remessa_entrega_futura_interestadual = e.target.checked
              this.props.calc.remessa_entrega_futura_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Retorno Remessa para Conserto (Estadual)"
            checked={this.props.calc.remessa_conserto_estadual}
            onChange={(e: any) => {
              this.props.calc.remessa_conserto_estadual = e.target.checked
              this.props.calc.remessa_conserto_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Retorno Remessa para Conserto (Interestadual)"
            checked={this.props.calc.remessa_conserto_interestadual}
            onChange={(e: any) => {
              this.props.calc.remessa_conserto_interestadual = e.target.checked
              this.props.calc.remessa_conserto_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Devolução de Venda (Estadual)"
            checked={this.props.calc.devolucao_venda_estadual}
            onChange={(e: any) => {
              this.props.calc.devolucao_venda_estadual = e.target.checked
              this.props.calc.devolucao_venda_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Devolução de Venda (Interestadual)"
            checked={this.props.calc.devolucao_venda_interestadual}
            onChange={(e: any) => {
              this.props.calc.devolucao_venda_interestadual = e.target.checked
              this.props.calc.devolucao_venda_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Outras entradas não especificadas (Estadual)"
            checked={this.props.calc.outras_entradas_estadual}
            onChange={(e: any) => {
              this.props.calc.outras_entradas_estadual = e.target.checked
              this.props.calc.outras_entradas_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Outras entradas não especificadas (Interestadual)"
            checked={this.props.calc.outras_entradas_interestadual}
            onChange={(e: any) => {
              this.props.calc.outras_entradas_interestadual = e.target.checked
              this.props.calc.outras_entradas_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Compra para utilização na prestação do Serviço (Estadual)"
            checked={this.props.calc.compra_prestacao_servico_estadual}
            onChange={(e: any) => {
              this.props.calc.compra_prestacao_servico_estadual = e.target.checked
              this.props.calc.compra_prestacao_servico_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Compra para utilização na prestação do Serviço (Interestadual)"
            checked={this.props.calc.compra_prestacao_servico_interestadual}
            onChange={(e: any) => {
              this.props.calc.compra_prestacao_servico_interestadual = e.target.checked
              this.props.calc.compra_prestacao_servico_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Entrada de Mercadoria para Demonstração (Estadual)"
            checked={this.props.calc.mercadorias_demonstracao_estadual}
            onChange={(e: any) => {
              this.props.calc.mercadorias_demonstracao_estadual = e.target.checked
              this.props.calc.mercadorias_demonstracao_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Entrada de Mercadoria para Demonstração (Interestadual)"
            checked={this.props.calc.mercadorias_demonstracao_interestadual}
            onChange={(e: any) => {
              this.props.calc.mercadorias_demonstracao_interestadual = e.target.checked
              this.props.calc.mercadorias_demonstracao_estadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Entrada de Mercadoria em Consignação (Estadual)"
            checked={this.props.calc.mercadorias_consignacao_estadual}
            onChange={(e: any) => {
              this.props.calc.mercadorias_consignacao_estadual = e.target.checked
              this.props.calc.mercadorias_consignacao_interestadual = false
            }}
          />

          <Switch
            className="select-regras"
            label="Entrada de Mercadoria em Consignação (Interestadual)"
            checked={this.props.calc.mercadorias_consignacao_interestadual}
            onChange={(e: any) => {
              this.props.calc.mercadorias_consignacao_interestadual = e.target.checked
              this.props.calc.mercadorias_consignacao_estadual = false
            }}
          />

        </div>

        <br /><br />

      </>

    )

  }

}

export default CalcClassificacaoUser;
